import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "shadow position-relative px-3 py-2 rounded-2 z-3 position-fixed access-as-container" };
const _hoisted_2 = {
    key: 0,
    class: "align-items-center d-flex gap-3"
};
const _hoisted_3 = { class: "mb-0 textInMobile" };
const _hoisted_4 = { class: "fw-bold" };
import { useStore } from "vuex";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccessAsCard',
    setup(__props) {
        const store = useStore();
        const userName = computed(() => store.getters.getName);
        const userWidth = computed(() => store.getters.getUserWidth);
        const openDisableAccesAsModal = () => {
            setTimeout(() => {
                store.dispatch('setModalData', { modalName: 'disableAccessAsModal', modalWrapperDiv: '.disableAccessAsModal' });
            }, 0);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (userWidth.value <= 1024)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)),
                        _createElementVNode("p", _hoisted_3, [
                            _cache[0] || (_cache[0] = _createTextVNode("Acessando como: ", -1)),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(userName.value || 'User Name'), 1)
                        ]),
                        _createElementVNode("div", {
                            onClick: openDisableAccesAsModal,
                            class: "cursor-pointer d-flex align-items-center justify-content-center border-0 position-absolute close-access-as-button"
                        }, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("i", { class: "text-white bi bi-x-lg" }, null, -1)
                            ]))])
                    ]))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        onClick: openDisableAccesAsModal,
                        class: "desktopText cursor-pointer mb-0"
                    }, [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Sair do modo \"acessar como\" ", -1),
                            _createElementVNode("i", { class: "ms-2 bi bi-x-lg" }, null, -1)
                        ]))]))
            ]));
        };
    }
});
